import Vue from 'vue'
export default {
  state: {
    groupOptionLegs: [],
    groupOptionChainStrikes: [],
    groupOptionLegStrikeList: [],
    groupEquityLeg: [],
    groupDistinctCallPut: null,
    groupStrategy: null,
    groupEquityTrade: {
      action: '',
      orderType: '',
      limitPrice: '',
      stopPrice: '',
      quantity: '',
      duration: '',
    },
    groupOptionTrade: {
      orderType: '',
      limitPrice: '',
      stopPrice: '',
      duration: '',
    },
    // stockQuote: { bid: 0, ask: 0, mid: 0 }
  },
  getters: {
    getGroupOptionChainStrikes: (state) => state.groupOptionChainStrikes,
    // getstockQuote: state => state.stockQuote,
    getGroupOptionLegs: (state) => state.groupOptionLegs,
    getGroupEquityTrade: (state) => state.groupEquityTrade,
    getGroupEquityLeg: (state) => state.groupEquityLeg,
    getGroupDistinctCallPut: (state) => state.groupDistinctCallPut,
    getGroupStrategy: (state) => state.groupStrategy,
    getGroupOptionLegStrikeList: (state) => state.groupOptionLegStrikeList,
    getGroupOptionTrade: (state) => state.groupOptionTrade,
  },
  mutations: {
    setGroupOptionChainStrikes: (state, payload) => {
      state.groupOptionChainStrikes = [
        ...new Set([...state.groupOptionChainStrikes, ...payload]),
      ]
      state.groupOptionChainStrikes = state.groupOptionChainStrikes.sort(
        (a, b) => a - b
      )
    },
    setGroupOptionLegStrikeList: (state, val) => {
      state.groupOptionLegStrikeList[val.index] = val.value
    },
    // setstockQuote: (state, val) => {
    //     state.stockQuote.bid = val.bid
    //     state.stockQuote.ask = val.ask
    //     state.stockQuote.mid = ((val.bid + val.ask) / 2).toFixed(2)
    //     if (state.groupEquityLeg[0]) {
    //         state.groupEquityLeg[0].bid = state.stockQuote.bid
    //         state.groupEquityLeg[0].ask = state.stockQuote.ask
    //         state.groupEquityLeg[0].mid = state.stockQuote.mid
    //     }
    // },
    // Group Option-----------------------------------------------------------
    setGroupOptionOrderType: (state, val) => {
      state.groupOptionTrade.orderType = val
    },
    setGroupOptionLimitPrice: (state, val) => {
      state.groupOptionTrade.limitPrice = val
    },
    setGroupOptionStopPrice: (state, val) => {
      state.groupOptionTrade.stopPrice = val
    },
    setGroupOptionDuration: (state, val) => {
      state.groupOptionTrade.duration = val
    },
    setGroupOptionLegAction: (state, val) => {
      state.groupOptionLegs[val.index].action = val.value
    },
    setGroupOptionLegQuantity: (state, val) => {
      state.groupOptionLegs[val.index].quantity = val.value
    },
    setGroupOptionLegSymbol: (state, val) => {
      state.groupOptionLegs[val.index].occSymbol = val.value
    },
    setGroupOptionLegExpiration: (state, val) => {
      state.groupOptionLegs[val.index].expiration = val.value
      state.groupOptionLegs[val.index].strike = null
    },
    setGroupOptionLegStrike: (state, val) => {
      state.groupOptionLegs[val.index].strike = val.value
    },
    setGroupOptionLegType: (state, val) => {
      state.groupOptionLegs[val.index].type = val.value
    },
    setGroupOptionSharesPerContract: (state, val) => {
      state.groupOptionLegs[val.index].sharesPerContract = val.value
    },
    addGroupLeg: (state, val) => {
      if (state.groupOptionLegs.length == 4) {
        Vue.notify({
          type: 'error',
          title: 'Error',
          text: 'Maximum of 4 legs can be added',
          duration: 3000,
        })
        return
      } else if (
        state.groupOptionLegs.length == 3 &&
        state.groupEquityLeg.length == 1
      ) {
        Vue.notify({
          type: 'error',
          title: 'Error',
          text: 'Maximum of 4 legs can be added',
          duration: 3000,
        })
        return
      }
      state.groupOptionLegs.push(val)
    },
    removeGroupLeg: (state, val) => {
      state.groupOptionLegs.splice(val, 1)
    },
    setGroupOptionLegs: (state, val) => {
      // state.groupEquityLeg = []
      state.groupOptionLegs = []
      val.forEach((item) => {
        // console.log("satte item", item)
        // if (item.legType == 'EQUITY') {
        //     state.groupEquityLeg.push(item)
        // }
        // else {
        state.groupOptionLegs.push(item)
        // }
      })
      // if (val.type == 2315 || [val.index].type == 2314) {
      // }
    },
    setGroupEquityLeg: (state, val) => {
      state.groupEquityLeg = []
      // state.groupOptionLegs = []
      // let leg = { action: Actions.Buy, quantity: 1, bid: state.stockQuote.bid, ask: state.stockQuote.ask, mid: state.stockQuote.mid, type: "EQUITY" }
      // if (leg.type == 'EQUITY' || val.type == 'EQUITY') {
      state.groupEquityLeg.push(val)
      // }
    },
    removeGroupEquityLeg: (state) => {
      state.groupEquityLeg = []
    },
    setGroupLegQuote: (state, val) => {
      state.groupOptionLegs[val.index].bid = val.bid.toFixed(2)
      state.groupOptionLegs[val.index].ask = val.ask.toFixed(2)
      state.groupOptionLegs[val.index].mid = ((val.bid + val.ask) / 2).toFixed(
        2
      )
    },
    setGroupEquityLegQuote: (state, val) => {
      if (state.groupEquityLeg[0]) {
        state.groupEquityLeg[0].bid = val.bid
        state.groupEquityLeg[0].ask = val.ask
        state.groupEquityLeg[0].mid = (
          (parseFloat(val.bid) + parseFloat(val.ask)) /
          2
        ).toFixed(2)
      }
    },
    setGroupDistinctCallPut: (state, val) => {
      state.groupDistinctCallPut = val
    },
    swapGroupActionContent: (state) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        if (leg.action == 276) {
          leg.action = 277
        } else if (leg.action == 277) {
          leg.action = 276
        } else if (leg.action == 278) {
          leg.action = 275
        } else if (leg.action == 275) {
          leg.action = 278
        }
      })
    },
    swapGroupTypeContent: (state) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        if (leg.type == 2315) {
          leg.type = 2314
        } else {
          leg.type = 2315
        }
      })
    },
    nextGroupStrike: (state, val) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.strike)
        leg.strike = val[index + 1]
      })
    },
    previousGroupStrike: (state, val) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.strike)
        leg.strike = val[index - 1]
      })
    },
    nextGroupExpiration: (state, val) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.expiration)
        leg.expiration = val[index + 1]
      })
    },
    previousGroupExpiration: (state, val) => {
      var items = state.groupOptionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.expiration)
        leg.expiration = val[index - 1]
      })
    },
    addGroupQuantityContent: (state, val) => {
      var items = state.groupOptionLegs
      var i = 0
      items.forEach((leg) => {
        i += 1
        var array = val.split('x')
        leg.quantity = parseInt(leg.quantity) + parseInt(array[i - 1])
        if (leg.quantity < 0) {
          leg.quantity = 0
        }
      })
      if (state.equityLeg.length > 0) {
        state.groupEquityLeg[0].quantity =
          state.groupOptionLegs[0].sharesPerContract *
          state.groupOptionLegs[0].quantity
      }
    },
    minusGroupQuantityContent: (state, val) => {
      var items = state.groupOptionLegs
      var i = 0
      items.forEach((leg) => {
        i += 1
        var array = val.split('x')
        leg.quantity = parseInt(leg.quantity) - parseInt(array[i - 1])
        if (leg.quantity < 0) {
          leg.quantity = 0
        }
      })
      if (state.equityLeg.length > 0) {
        state.groupEquityLeg[0].quantity =
          state.groupOptionLegs[0].sharesPerContract *
          state.groupOptionLegs[0].quantity
      }
    },
    // Group Equity-----------------------------------------------------------
    setGroupEquityTradeLimitPrice: (state, val) => {
      state.groupEquityTrade.limitPrice = val
    },
    setGroupEquityTradeStopPrice: (state, val) => {
      state.groupEquityTrade.stopPrice = val
    },
    setGroupEquityTradeAction: (state, val) => {
      state.groupEquityTrade.action = val
    },
    setGroupEquityTradeQuantity: (state, val) => {
      state.groupEquityTrade.quantity = val
    },
    setGroupEquityTradeOrderType: (state, val) => {
      state.groupEquityTrade.orderType = val
    },
    setGroupEquityTradeDuration: (state, val) => {
      state.groupEquityTrade.duration = val
    },
    setGroupEquityAction: (state, val) => {
      state.groupEquityLeg[0].action = val
    },
    setGroupEquityQuantity: (state, val) => {
      state.groupEquityLeg[0].quantity = val
    },
    setGroupStrategy: (state) => {
      // console.log(val)
      console.log(state)
      // if (val.length == 0) {
      //     state.groupStrategy = null
      // }
      // console.log("equityleg", state.groupEquityLeg)
      // console.log("groupOptionLegs", state.groupOptionLegs)
      if (state.groupEquityLeg.length == 0) {
        if (state.groupOptionLegs.length != 0) {
          if (state.groupOptionLegs.length == 1) {
            if (state.groupOptionLegs[0].type == 2315) {
              if (state.groupOptionLegs[0].action == 276) {
                state.groupStrategy = 'LONG_CALL'
              } else if (state.groupOptionLegs[0].action == 277) {
                state.groupStrategy = 'SHORT_CALL'
              } else {
                //error
                state.groupStrategy = 'CUSTOM'
                console.log('error single leg')
              }
            } else {
              if (state.groupOptionLegs[0].action == 276) {
                state.groupStrategy = 'LONG_PUT'
              } else if (state.groupOptionLegs[0].action == 277) {
                state.groupStrategy = 'SHORT_PUT'
              } else {
                //error
                state.groupStrategy = 'CUSTOM'
                console.log('error')
              }
            }
          }
          if (state.groupOptionLegs.length == 2) {
            if (
              state.groupOptionLegs[0].type == state.groupOptionLegs[1].type
            ) {
              if (
                state.groupOptionLegs[0].expiration ==
                state.groupOptionLegs[1].expiration
              ) {
                // if (state.groupOptionLegs[0].strike < state.groupOptionLegs[1].strike) {
                if (
                  state.groupOptionLegs[0].quantity ==
                  state.groupOptionLegs[1].quantity
                ) {
                  if (
                    state.groupOptionLegs[0].action == 276 &&
                    state.groupOptionLegs[1].action == 277
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'LONG_CALL_SPREAD'
                    } else {
                      state.groupStrategy = 'SHORT_PUT_SPREAD'
                    }
                  } else if (
                    state.groupOptionLegs[0].action == 277 &&
                    state.groupOptionLegs[1].action == 276
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'SHORT_CALL_SPREAD'
                    } else {
                      state.groupStrategy = 'LONG_PUT_SPREAD'
                    }
                  } else {
                    // THROW AN ERROR
                    state.groupStrategy = 'ERROR'
                    console.log('error')
                  }
                  // }
                } else {
                  state.groupStrategy = 'CUSTOM'
                  // console.log("error")
                }
              } else if (
                state.groupOptionLegs[0].strike ==
                state.groupOptionLegs[1].strike
              ) {
                // calendar
                var date0Updated = new Date(
                  state.groupOptionLegs[0].expiration.replace(/-/g, '/')
                )
                var date1Updated = new Date(
                  state.groupOptionLegs[1].expiration.replace(/-/g, '/')
                )
                if (date0Updated > date1Updated) {
                  if (
                    state.groupOptionLegs[0].action == 276 &&
                    state.groupOptionLegs[1].action == 277
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'LONG_CALL_CALENDAR'
                    } else {
                      state.groupStrategy = 'LONG_PUT_CALENDAR'
                    }
                  } else if (
                    state.groupOptionLegs[0].action == 277 &&
                    state.groupOptionLegs[1].action == 276
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'SHORT_CALL_CALENDAR'
                    } else {
                      state.groupStrategy = 'SHORT_PUT_CALENDAR'
                    }
                  }
                }
                //this section below causes problems due to the sorting of strikes and expirations but works without it
                // else {
                //     if (state.groupOptionLegs[0].action == 276 && state.groupOptionLegs[1].action == 277) {
                //         if (state.groupOptionLegs[0].type == 2315) {
                //             state.groupStrategy = "SHORT_CALL_CALENDAR"
                //         }
                //         else {
                //             state.groupStrategy = "SHORT_PUT_CALENDAR"
                //         }
                //     }
                //     else if (state.groupOptionLegs[0].action == 277 && state.groupOptionLegs[1].action == 276) {
                //         if (state.groupOptionLegs[0].type == 2315) {
                //             state.groupStrategy = "LONG_CALL_CALENDAR"
                //         }
                //         else {
                //             state.groupStrategy = "LONG_PUT_CALENDAR"
                //         }
                //     }
                //     else {
                //         // THROW AN ERROR
                //         state.groupStrategy = "CUSTOM"
                //         console.log("error")
                //     }
                // }
              } else {
                // "diagonal"
                var date0Diagonal = new Date(
                  state.groupOptionLegs[0].expiration.replace(/-/g, '/')
                )
                var date1Diagonal = new Date(
                  state.groupOptionLegs[1].expiration.replace(/-/g, '/')
                )
                if (date0Diagonal > date1Diagonal) {
                  if (
                    state.groupOptionLegs[0].action == 276 &&
                    state.groupOptionLegs[1].action == 277
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'LONG_CALL_DIAGONAL'
                    } else {
                      state.groupStrategy = 'LONG_PUT_DIAGONAL'
                    }
                  } else if (
                    state.groupOptionLegs[0].action == 277 &&
                    state.groupOptionLegs[1].action == 276
                  ) {
                    if (state.groupOptionLegs[0].type == 2315) {
                      state.groupStrategy = 'SHORT_CALL_DIAGONAL'
                    } else {
                      state.groupStrategy = 'SHORT_PUT_DIAGONAL'
                    }
                  } else {
                    // THROW AN ERROR
                    state.groupStrategy = 'CUSTOM'
                    console.log('error')
                  }
                }
                // else {
                //     if (state.groupOptionLegs[0].action == 276 && state.groupOptionLegs[1].action == 277) {
                //         if (state.groupOptionLegs[0].type == 2315) {
                //             state.groupStrategy = "SHORT_CALL_DIAGONAL"
                //         }
                //         else {
                //             state.groupStrategy = "SHORT_PUT_DIAGONAL"
                //         }
                //     }
                //     else if (state.groupOptionLegs[0].action == 277 && state.groupOptionLegs[1].action == 276) {
                //         if (state.groupOptionLegs[0].type == 2315) {
                //             state.groupStrategy = "LONG_CALL_DIAGONAL"
                //         }
                //         else {
                //             state.groupStrategy = "LONG_PUT_DIAGONAL"
                //         }
                //     }
                //     else {
                //         // THROW AN ERROR
                //         state.groupStrategy = "CUSTOM"
                //         console.log("error")
                //     }
                // }
              }
            } else {
              if (
                state.groupOptionLegs[0].expiration ==
                state.groupOptionLegs[1].expiration
              ) {
                if (
                  state.groupOptionLegs[0].strike ==
                  state.groupOptionLegs[1].strike
                ) {
                  if (state.groupOptionLegs[0].type == 2315) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_STRADDLE'
                    }
                    if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_STRADDLE'
                    }
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SYNTHETIC_LONG'
                    }
                    if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'SYNTHETIC_SHORT'
                    }
                    // else {
                    //     //throw an error
                    //     state.groupStrategy = "CUSTOM"
                    //     console.log("error")
                    // }
                  } else {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_STRADDLE'
                    }
                    if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_STRADDLE'
                    }
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SYNTHETIC_SHORT'
                    }
                    if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'SYNTHETIC_LONG'
                    }
                    // else {
                    //     //throw an error
                    //     state.groupStrategy = "CUSTOM"
                    //     console.log("error")
                    // }
                  }
                } else if (state.groupOptionLegs[0].type == 2314) {
                  if (
                    state.groupOptionLegs[0].strike <
                    state.groupOptionLegs[1].strike
                  ) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else {
                      state.groupStrategy = 'CUSTOM'
                      console.log('error')
                    }
                  } else if (
                    state.groupOptionLegs[0].strike >
                    state.groupOptionLegs[1].strike
                  ) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_GUTS_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_GUTS_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else {
                      state.groupStrategy = 'CUSTOM'
                      console.log('error')
                    }
                  }
                } else {
                  if (
                    state.groupOptionLegs[1].strike <
                    state.groupOptionLegs[0].strike
                  ) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else {
                      //error
                      state.groupStrategy = 'CUSTOM'
                      console.log('error')
                    }
                  } else if (
                    state.groupOptionLegs[1].strike >
                    state.groupOptionLegs[0].strike
                  ) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'LONG_GUTS_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'SHORT_GUTS_STRANGLE'
                    } else if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      state.groupStrategy = 'CUSTOM'
                    } else {
                      //error
                      state.groupStrategy = 'CUSTOM'
                      console.log('error')
                    }
                  }
                }
              } else {
                //error
                state.groupStrategy = 'ERROR'
                console.log('error') //idk if this is an error
              }
            }
            // else {
            //     //TODO throw an error - make a groupStrategy callled error and check where permissions are being checked
            //     //if error instate.groupOptionLegsid trade type and can make a pop out that way
            //     state.groupStrategy = "CUSTOM"
            //     console.log("error")
            // }
          } else if (state.groupOptionLegs.length == 3) {
            // if (state.groupOptionLegs[0].type == state.groupOptionLegs[2].type && state.groupOptionLegs[1].type != state.groupOptionLegs[0].type) {
            //     if (state.groupOptionLegs[0].type == 2315){

            //     }
            // }
            if (
              state.groupOptionLegs[0].expiration ==
                state.groupOptionLegs[1].expiration &&
              state.groupOptionLegs[1].expiration ==
                state.groupOptionLegs[2].expiration
            ) {
              if (
                state.groupOptionLegs[0].type ==
                  state.groupOptionLegs[2].type &&
                state.groupOptionLegs[1].type == state.groupOptionLegs[2].type
              ) {
                if (
                  state.groupOptionLegs[0].quantity ==
                    state.groupOptionLegs[2].quantity &&
                  state.groupOptionLegs[1].quantity ==
                    state.groupOptionLegs[0].quantity * 2
                ) {
                  if (
                    state.groupOptionLegs[0].action ==
                      state.groupOptionLegs[2].action &&
                    state.groupOptionLegs[2].action !=
                      state.groupOptionLegs[1].action
                  ) {
                    if (
                      state.groupOptionLegs[0].action == 276 &&
                      state.groupOptionLegs[1].action == 277
                    ) {
                      if (state.groupOptionLegs[0].type == 2315) {
                        state.groupStrategy = 'LONG_CALL_BUTTERFLY'
                      } else {
                        state.groupStrategy = 'LONG_PUT_BUTTERFLY'
                      }
                    } else if (
                      state.groupOptionLegs[0].action == 277 &&
                      state.groupOptionLegs[1].action == 276
                    ) {
                      if (state.groupOptionLegs[0].type == 2315) {
                        state.groupStrategy = 'SHORT_CALL_BUTTERFLY'
                      } else {
                        state.groupStrategy = 'SHORT_PUT_BUTTERFLY'
                      }
                    }
                  } else {
                    state.groupStrategy = 'CUSTOM'
                    console.log('error')
                  }
                } else {
                  state.groupStrategy = 'ERROR'
                  console.log('error')
                }
              }
            } else {
              state.groupStrategy = 'CUSTOM'
              console.log('error')
            }
          } else if (state.groupOptionLegs.length == 4) {
            if (
              state.groupOptionLegs[0].type == state.groupOptionLegs[1].type &&
              state.groupOptionLegs[1].type == state.groupOptionLegs[2].type &&
              state.groupOptionLegs[1].type == state.groupOptionLegs[3].type
            ) {
              if (
                state.groupOptionLegs[0].expiration ==
                  state.groupOptionLegs[1].expiration &&
                state.groupOptionLegs[1].expiration ==
                  state.groupOptionLegs[2].expiration &&
                state.groupOptionLegs[1].expiration ==
                  state.groupOptionLegs[3].expiration
              ) {
                if (
                  state.groupOptionLegs[0].action ==
                    state.groupOptionLegs[3].action &&
                  state.groupOptionLegs[1].action ==
                    state.groupOptionLegs[2].action &&
                  state.groupOptionLegs[2].action !=
                    state.groupOptionLegs[0].action
                ) {
                  if (state.groupOptionLegs[0].type == 2315) {
                    if (state.groupOptionLegs[0].action == 276) {
                      state.groupStrategy = 'LONG_CALL_CONDOR'
                    } else if (state.groupOptionLegs[0].action == 277) {
                      state.groupStrategy = 'SHORT_CALL_CONDOR'
                    }
                  } else {
                    if (state.groupOptionLegs[0].action == 276) {
                      state.groupStrategy = 'LONG_PUT_CONDOR'
                    } else if (state.groupOptionLegs[0].action == 277) {
                      state.groupStrategy = 'SHORT_PUT_CONDOR'
                    }
                  }
                } else {
                  state.groupStrategy = 'ERROR'
                }
              } else {
                state.groupStrategy = 'ERROR'
              }
            } else if (
              state.groupOptionLegs[0].type &&
              state.groupOptionLegs[1].type == 2314 &&
              state.groupOptionLegs[2].type &&
              state.groupOptionLegs[3].type == 2315
            ) {
              if (
                state.groupOptionLegs[0].expiration ==
                  state.groupOptionLegs[1].expiration &&
                state.groupOptionLegs[2].expiration ==
                  state.groupOptionLegs[3].expiration &&
                state.groupOptionLegs[2].expiration ==
                  state.groupOptionLegs[1].expiration
              ) {
                if (
                  state.groupOptionLegs[0].action ==
                    state.groupOptionLegs[1].action &&
                  state.groupOptionLegs[2].action ==
                    state.groupOptionLegs[3].action &&
                  state.groupOptionLegs[2].action !=
                    state.groupOptionLegs[0].action
                ) {
                  if (
                    state.groupOptionLegs[1].strike ==
                    state.groupOptionLegs[2].strike
                  ) {
                    if (state.groupOptionLegs[0].action == 276) {
                      state.groupStrategy = 'LONG_IRON_BUTTERFLY'
                    }
                    if (state.groupOptionLegs[0].action == 277) {
                      state.groupStrategy = 'SHORT_IRON_BUTTERFLY'
                    }
                  } else {
                    if (state.groupOptionLegs[0].action == 276) {
                      state.groupStrategy = 'LONG_IRON_CONDOR'
                    } else if (state.groupOptionLegs[0].action == 277) {
                      state.groupStrategy = 'SHORT_IRON_CONDOR'
                    } else {
                      state.groupStrategy = 'CUSTOM'
                    }
                  }
                }
              } else {
                // var date0DD = new Date(state.groupOptionLegs[0].expiration.replace(/-/g, '/'));//TODO for comparing dates use getTime()
                // var date1DD = new Date(state.groupOptionLegs[1].expiration.replace(/-/g, '/'));
                if (
                  state.groupOptionLegs[1].expiration ==
                    state.groupOptionLegs[2].expiration &&
                  state.groupOptionLegs[0].expiration ==
                    state.groupOptionLegs[3].expiration &&
                  state.groupOptionLegs[2].expiration !=
                    state.groupOptionLegs[1].expiration
                ) {
                  // if (state.groupOptionLegs[0].type && state.groupOptionLegs[1].type == 2314 && state.groupOptionLegs[2].type && state.groupOptionLegs[3].type == 2315) {
                  if (
                    state.groupOptionLegs[1].action ==
                      state.groupOptionLegs[2].action &&
                    state.groupOptionLegs[0].action ==
                      state.groupOptionLegs[3].action &&
                    state.groupOptionLegs[2].action !=
                      state.groupOptionLegs[0].action
                  ) {
                    if (state.groupOptionLegs[0].action == 276) {
                      state.groupStrategy = 'LONG_DOUBLE_DIAGONAL'
                    }
                    if (state.groupOptionLegs[0].action == 277) {
                      state.groupStrategy = 'SHORT_DOUBLE_DIAGONAL'
                    }
                  }
                  // }
                }
                // else if (state.groupOptionLegs[1].expiration == state.groupOptionLegs[2].expiration && state.groupOptionLegs[0].expiration == state.groupOptionLegs[3].expiration && state.groupOptionLegs[2].expiration != state.groupOptionLegs[1].expiration && date1DD > date0DD) {
                //     if (state.groupOptionLegs[0].type && state.groupOptionLegs[1].type == 2314 && state.groupOptionLegs[2].type && state.groupOptionLegs[3].type == 2315) {
                //         if (state.groupOptionLegs[1].action == state.groupOptionLegs[2].action && state.groupOptionLegs[0].action == state.groupOptionLegs[3].action && state.groupOptionLegs[2].action != state.groupOptionLegs[0].action) {
                //             if (state.groupOptionLegs[0].action == 276) {
                //                 state.groupStrategy = "SHORT_DOUBLE_DIAGONAL"
                //             }
                //             if (state.groupOptionLegs[0].action == 277) {
                //                 state.groupStrategy = "LONG_DOUBLE_DIAGONAL"
                //             }
                //         }
                //     }
                // }
                // else {
                //     state.groupStrategy = "ERROR"
                // }
              }
            }
          }
        } else {
          state.groupStrategy = null
        }
      } else {
        //TODO need to incoorporate positons into this
        // cash secured put
        if (state.groupOptionLegs.length == 1) {
          if (state.groupOptionLegs[0].type == 2314) {
            if (
              state.groupOptionLegs[0].action == 276 &&
              state.groupEquityLeg[0].action == 279
            ) {
              state.groupStrategy = 'MARRIED_PUT'
            } else if (
              state.groupOptionLegs[0].action == 277 &&
              state.groupEquityLeg[0].action == 281
            ) {
              state.groupStrategy = 'COVERED_PUT'
            }
            //equity leg 1 option leg married put
          } else if (state.groupOptionLegs[0].type == 2315) {
            if (
              state.groupOptionLegs[0].action == 276 &&
              state.groupEquityLeg[0].action == 281
            ) {
              state.groupStrategy = 'MARRIED_CALL'
            } else if (
              state.groupOptionLegs[0].action == 277 &&
              state.groupEquityLeg[0].action == 279
            ) {
              state.groupStrategy = 'COVERED_CALL'
            }
          } else {
            state.groupStrategy = 'CUSTOM'
          }
        }
        if (state.groupOptionLegs.length == 2) {
          if (
            state.groupOptionLegs[0].type == 2314 &&
            state.groupOptionLegs[1].type == 2315
          ) {
            if (
              state.groupOptionLegs[0].action == 276 &&
              state.groupOptionLegs[1].action == 277
            ) {
              if (state.groupEquityLeg[0].action == 279) {
                state.groupStrategy = 'COLLAR'
              }
            }
          } else {
            state.groupStrategy = 'CUSTOM'
          }
        }
      }
    },
  },

  actions: {},
}
